/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EngineType } from './EngineType';
import {
    EngineTypeFromJSON,
    EngineTypeFromJSONTyped,
    EngineTypeToJSON,
    EngineTypeToJSONTyped,
} from './EngineType';
import type { ProcurementType } from './ProcurementType';
import {
    ProcurementTypeFromJSON,
    ProcurementTypeFromJSONTyped,
    ProcurementTypeToJSON,
    ProcurementTypeToJSONTyped,
} from './ProcurementType';

/**
 * 
 * @export
 * @interface VehicleUpdate
 */
export interface VehicleUpdate {
    /**
     * The `active` field only exists in the update struct. Newly created vehicles are always active, and the active status in incorporated into the `VehicleStatus` for `Vehicle`.
     * @type {boolean}
     * @memberof VehicleUpdate
     */
    active?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    vehicleTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    manufactureYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    shockProfileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    phoneImei?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUpdate
     */
    preOpsChecklistId?: string | null;
    /**
     * 
     * @type {ProcurementType}
     * @memberof VehicleUpdate
     */
    procurementType?: ProcurementType | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleUpdate
     */
    purchaseDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleUpdate
     */
    contractTermStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleUpdate
     */
    contractTermEnd?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    purchaseCost?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    monthlyCost?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    initialOperatingHours?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    idleAutoLogoutAfter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    maintenanceInterval?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    maintenanceNotificationAt?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUpdate
     */
    maintenanceLockdown?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUpdate
     */
    checklistOverride?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    weeklyDriveGoalHours?: number | null;
    /**
     * 
     * @type {EngineType}
     * @memberof VehicleUpdate
     */
    engineType?: EngineType | null;
    /**
     * Only super admin users are allowed to change this value.
     * @type {number}
     * @memberof VehicleUpdate
     */
    magneticFieldThreshold?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    motionStartThresholdMv?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    motionStopThresholdMv?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    motionStartDelayMs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    motionStopDelayMs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUpdate
     */
    speakerVolume?: number | null;
}



/**
 * Check if a given object implements the VehicleUpdate interface.
 */
export function instanceOfVehicleUpdate(value: object): value is VehicleUpdate {
    return true;
}

export function VehicleUpdateFromJSON(json: any): VehicleUpdate {
    return VehicleUpdateFromJSONTyped(json, false);
}

export function VehicleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        'vehicleTypeId': json['vehicleTypeId'] == null ? undefined : json['vehicleTypeId'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'manufactureYear': json['manufactureYear'] == null ? undefined : json['manufactureYear'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shockProfileId': json['shockProfileId'] == null ? undefined : json['shockProfileId'],
        'phoneImei': json['phoneImei'] == null ? undefined : json['phoneImei'],
        'preOpsChecklistId': json['preOpsChecklistId'] == null ? undefined : json['preOpsChecklistId'],
        'procurementType': json['procurementType'] == null ? undefined : ProcurementTypeFromJSON(json['procurementType']),
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'contractTermStart': json['contractTermStart'] == null ? undefined : (new Date(json['contractTermStart'])),
        'contractTermEnd': json['contractTermEnd'] == null ? undefined : (new Date(json['contractTermEnd'])),
        'purchaseCost': json['purchaseCost'] == null ? undefined : json['purchaseCost'],
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'initialOperatingHours': json['initialOperatingHours'] == null ? undefined : json['initialOperatingHours'],
        'idleAutoLogoutAfter': json['idleAutoLogoutAfter'] == null ? undefined : json['idleAutoLogoutAfter'],
        'maintenanceInterval': json['maintenanceInterval'] == null ? undefined : json['maintenanceInterval'],
        'maintenanceNotificationAt': json['maintenanceNotificationAt'] == null ? undefined : json['maintenanceNotificationAt'],
        'maintenanceLockdown': json['maintenanceLockdown'] == null ? undefined : json['maintenanceLockdown'],
        'checklistOverride': json['checklistOverride'] == null ? undefined : json['checklistOverride'],
        'weeklyDriveGoalHours': json['weeklyDriveGoalHours'] == null ? undefined : json['weeklyDriveGoalHours'],
        'engineType': json['engineType'] == null ? undefined : EngineTypeFromJSON(json['engineType']),
        'magneticFieldThreshold': json['magneticFieldThreshold'] == null ? undefined : json['magneticFieldThreshold'],
        'motionStartThresholdMv': json['motionStartThresholdMv'] == null ? undefined : json['motionStartThresholdMv'],
        'motionStopThresholdMv': json['motionStopThresholdMv'] == null ? undefined : json['motionStopThresholdMv'],
        'motionStartDelayMs': json['motionStartDelayMs'] == null ? undefined : json['motionStartDelayMs'],
        'motionStopDelayMs': json['motionStopDelayMs'] == null ? undefined : json['motionStopDelayMs'],
        'speakerVolume': json['speakerVolume'] == null ? undefined : json['speakerVolume'],
    };
}

export function VehicleUpdateToJSON(json: any): VehicleUpdate {
    return VehicleUpdateToJSONTyped(json, false);
}

export function VehicleUpdateToJSONTyped(value?: VehicleUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        'vehicleTypeId': value['vehicleTypeId'],
        'serialNumber': value['serialNumber'],
        'manufactureYear': value['manufactureYear'],
        'departmentId': value['departmentId'],
        'shockProfileId': value['shockProfileId'],
        'phoneImei': value['phoneImei'],
        'preOpsChecklistId': value['preOpsChecklistId'],
        'procurementType': ProcurementTypeToJSON(value['procurementType']),
        'purchaseDate': value['purchaseDate'] == null ? value['purchaseDate'] : value['purchaseDate'].toISOString(),
        'contractTermStart': value['contractTermStart'] == null ? value['contractTermStart'] : value['contractTermStart'].toISOString(),
        'contractTermEnd': value['contractTermEnd'] == null ? value['contractTermEnd'] : value['contractTermEnd'].toISOString(),
        'purchaseCost': value['purchaseCost'],
        'monthlyCost': value['monthlyCost'],
        'initialOperatingHours': value['initialOperatingHours'],
        'idleAutoLogoutAfter': value['idleAutoLogoutAfter'],
        'maintenanceInterval': value['maintenanceInterval'],
        'maintenanceNotificationAt': value['maintenanceNotificationAt'],
        'maintenanceLockdown': value['maintenanceLockdown'],
        'checklistOverride': value['checklistOverride'],
        'weeklyDriveGoalHours': value['weeklyDriveGoalHours'],
        'engineType': EngineTypeToJSON(value['engineType']),
        'magneticFieldThreshold': value['magneticFieldThreshold'],
        'motionStartThresholdMv': value['motionStartThresholdMv'],
        'motionStopThresholdMv': value['motionStopThresholdMv'],
        'motionStartDelayMs': value['motionStartDelayMs'],
        'motionStopDelayMs': value['motionStopDelayMs'],
        'speakerVolume': value['speakerVolume'],
    };
}

